module.exports = __webpack_public_path__ + "img/erweima.70f31135.jpg";